
















































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { RelatorioDisparosModel } from "@/models/administracao/comunicacao/RelatorioDisparosModel";
import NotificacoesService from "@/service/notificacoes/NotificacoesService";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioDisparos extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };


  lista = [];
  tableHeader = [
    { text: 'CPF / CNPJ', value: 'cpfCnpj', width: '15%'  },
    { text: 'Nome', value: 'nome', width: '30%' },
    { text: 'Tipo De Comunicação', value: 'tipoDeComunicacao', width: '15%' },
    { text: 'Data Envio / A Enviar', value: 'dataEnvio', width: '15%' },
    { text: 'Trigger de Disparo', value: 'descricaoGatilho', width: '25%' },
  ];


  tiposComunicacao = [
    { valor: 'EMAIL', descricao: 'E-mail' },
    { valor: 'SMS', descricao: 'SMS' },
    { valor: 'PUSH', descricao: 'Push' }
  ];

  disparos: any[] = [];

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  filtro: RelatorioDisparosModel = {
    cpfCnpj: undefined,
	  tipoComunicacao: undefined,
	  dataEnvio: undefined
  };

  getData() {
    this.disparos = [];
       NotificacoesService
      .relatorioDisparo(this.filtro).then((res: any) => {
        console.log(res);
        this.disparos = (res.data as any);
      })
      .catch((err) => {
        this.loading = false;
        this.openDialog(false, "Disparos" , "Erro ao consultar disparos."); 
        console.log(err);
      });
      
  }

  public gerarRelatorio(tipo: string): void {
    this.loading = true;
    NotificacoesService.gerarRelatorioDisparo(tipo, this.filtro)
      .then((res) => {
        let fileURL = window.URL.createObjectURL(new Blob([res.data]));

        let fileLink = document.createElement("a");

        fileLink.href = fileURL;

        fileLink.setAttribute(
          "download",
          `relatorio_disparos.${
            tipo.toLowerCase() === "excel" ? "xls" : "pdf"
          }`
        );

        document.body.appendChild(fileLink);

        fileLink.click();

        this.loading = false;
      })
      .catch((err) => {
        this.openDialog(false, "Erro", "Problemas ao gerar relatório.");
        this.loading = false;
      });

    this.limparformulario();
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  public limparformulario(): void {
    this.filtro = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
